import { Outlet } from "react-router-dom";
import { useCompaniesStore } from "../../store/admin/companiesStore";

/**
 * Renderiza el <Outlet/> re-montándolo cuando cambia la compañía activa
 * (companyId del store, persistida en localStorage y usada por el api client
 * para scopear las peticiones).
 *
 * Útil en apps cuyo contenido se obtiene en el montaje y NO se suscribe a
 * companyId (POS, Bases y Propiedades, Control de Acceso). Cuando el admin
 * reseller cambia de compañía con el selector del Header, la vista actual se
 * refresca con los datos de la nueva compañía.
 *
 * Para usuarios no-reseller el companyId no cambia, por lo que el key es
 * estable y no hay re-montaje (comportamiento idéntico a <Outlet/>).
 */
export default function CompanyScopedOutlet() {
  const companyId = useCompaniesStore((state) => state.companyId);
  return <Outlet key={companyId ?? "none"} />;
}
